import * as types from './actionTypes';

export const fetchSalaryScale = (unit_id) => ({
  type: types.FETCH_SALARY_SCALE,
  payload:{unit_id}
});

export const saveSalaryScale = (payload) => ({
  type: types.SAVE_SALARY_SCALE,
  payload,
});

export const changeSalaryScaleStatus = (payload) => ({
  type: types.CHANGE_SALARY_SCALE_STATUS,
  payload,
});
